import React from 'react';
import { Button, Grid, Header, Segment, Table } from 'semantic-ui-react';
import { formatCount } from './utils';

const RankingTable = ({ title, rows, nameKey, renderName, onDrillDown }) => (
  <Segment className='error-stats-panel'>
    <Header as='h3'>{title}</Header>
    <Table compact basic='very'>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>排名</Table.HeaderCell>
          <Table.HeaderCell>{title.replace('排行', '')}</Table.HeaderCell>
          <Table.HeaderCell textAlign='right'>失败数</Table.HeaderCell>
          <Table.HeaderCell textAlign='right'>操作</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {(rows || []).slice(0, 10).map((row, index) => (
          <Table.Row key={`${nameKey}-${row[nameKey]}-${index}`}>
            <Table.Cell>{index + 1}</Table.Cell>
            <Table.Cell>{renderName(row)}</Table.Cell>
            <Table.Cell textAlign='right'>
              {formatCount(row.failure_count)}
            </Table.Cell>
            <Table.Cell textAlign='right'>
              <Button size='mini' basic onClick={() => onDrillDown(row)}>
                查看
              </Button>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  </Segment>
);

const RankingPanels = ({ models, channels, onModelClick, onChannelClick }) => (
  <Grid stackable columns={2}>
    <Grid.Column>
      <RankingTable
        title='影响模型排行'
        rows={models}
        nameKey='model_name'
        renderName={(row) => row.model_name || '未知模型'}
        onDrillDown={(row) => onModelClick(row.model_name)}
      />
    </Grid.Column>
    <Grid.Column>
      <RankingTable
        title='失败渠道排行'
        rows={channels}
        nameKey='channel_id'
        renderName={(row) =>
          row.channel_name
            ? `${row.channel_name}（ID: ${row.channel_id}）`
            : `渠道 ${row.channel_id || '未知'}`
        }
        onDrillDown={(row) => onChannelClick(row.channel_id)}
      />
    </Grid.Column>
  </Grid>
);

export default RankingPanels;
